import type { AuthError } from "@supabase/supabase-js";
import {
  CAPTCHA_ERROR_MESSAGE,
  captchaFailureMessage,
  executeTurnstile,
  type CaptchaAction,
  type ExecuteTurnstileOptions,
} from "@ugg/shared/utils/captcha";

export const mintAuthCaptcha = async (
  action: CaptchaAction,
  setError: (message: string) => void,
  options?: ExecuteTurnstileOptions,
) => {
  try {
    const { token } = await executeTurnstile(action, options);
    return token;
  } catch (err) {
    setError(captchaFailureMessage(err, action) ?? "");
    return null;
  }
};

export const authErrorMessage = (error: AuthError) =>
  error.code === "captcha_failed" ? CAPTCHA_ERROR_MESSAGE : error.message;
